import React from 'react';
import styles from './index.module.scss';

const UnknownImgsBlock = ({
  contentData,
  contentText,
  imgName,
  imgsNames,
  videoName,
  path_to_folder,
}) => {

  // Обработка imgsNames - преобразуем в массив и обрабатываем пути
  const processedImgsNames = React.useMemo(() => {
    if (!imgsNames || imgsNames === '' || imgsNames === '[]') return [];

    let imagesArray = [];

    // Если это строка, пытаемся распарсить как JSON
    if (typeof imgsNames === 'string') {
      try {
        imagesArray = JSON.parse(imgsNames);
      } catch (e) {
        // Если не JSON, разделяем по запятым
        imagesArray = imgsNames
          .split(',')
          .map((img) => img.trim())
          .filter((img) => img && img !== 'none');
      }
    } else if (Array.isArray(imgsNames)) {
      imagesArray = imgsNames.filter((img) => img && img !== 'none');
    }

    // Обрабатываем каждый путь изображения
    return imagesArray.map((imgName) => {
      if (imgName && imgName.includes('\\')) {
        return imgName.substring(imgName.lastIndexOf('\\') + 1);
      }
      return imgName;
    });
  }, [imgsNames]);

  return (
    <div className={styles.unknownImgsBlock}>
      <h2 className={styles.title}>Неизвестный Блок Изображений</h2>
      <p className={styles.description}>Компонент для неизвестного блока изображений</p>

      {processedImgsNames && processedImgsNames.length > 0 && (
        <div className={styles.galleryContainer}>
          <h4>Галерея изображений:</h4>
          <div className={styles.galleryGrid}>
            {processedImgsNames.map((processedImgName, index) => (
              <div key={index} className={styles.galleryItem}>
                <p className={styles.imagePath}>Путь: {path_to_folder + processedImgName}</p>
                <img
                  src={path_to_folder + processedImgName}
                  alt={`Изображение ${index + 1}`}
                  className={styles.galleryImage}
                />
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default UnknownImgsBlock;
